import { render, staticRenderFns } from "./OffersProductsTable.vue?vue&type=template&id=4eb8c6a9&scoped=true"
import script from "./OffersProductsTable.vue?vue&type=script&lang=js"
export * from "./OffersProductsTable.vue?vue&type=script&lang=js"
import style0 from "./OffersProductsTable.vue?vue&type=style&index=0&id=4eb8c6a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb8c6a9",
  null
  
)

export default component.exports